import MetisMenu from "metismenujs"

// Just over the 0.35s `.mm-collapsing` CSS transition.
const TRANSITION_GUARD_MS = 500

/**
 * MetisMenu ignores every click while a submenu is "transitioning" and only clears
 * that on `transitionend`. When the transition is cut short (a submenu opened or
 * restyled mid-animation, collapsed rail, hidden sidebar) the event never fires and
 * every dropdown stays stuck until a reload. This finishes the transition ourselves.
 */
export const createMetisMenu = (menuEl, options) => {
  const metis = new MetisMenu(menuEl, options)
  const setTransitioning = metis.setTransitioning.bind(metis)

  metis.setTransitioning = isTransitioning => {
    setTransitioning(isTransitioning)
    clearTimeout(metis.transitionGuardTimer)
    if (!isTransitioning) return
    metis.transitionGuardTimer = setTimeout(() => {
      metis.element.querySelectorAll(".mm-collapsing").forEach(ul => {
        ul.classList.remove("mm-collapsing")
        ul.classList.add("mm-collapse")
        ul.style.height = ""
      })
      setTransitioning(false)
    }, TRANSITION_GUARD_MS)
  }

  return metis
}

export const disposeMetisMenu = metis => {
  if (!metis) return
  clearTimeout(metis.transitionGuardTimer)
  if (typeof metis.dispose === "function") metis.dispose()
}
